import React from "react"
import { Image, Flex, Box, Text } from "rebass"

import Reveal from "../reveals"
import RowWrapper from "./RowWrapper"
import VideoPlayer from "./VideoPlayer"

const RowIntroComponent = ({ data }) => {
  const {
    image,
    video,
    videoMobile,
    title,
    titleHeadingTag,
    text,
    revealAnimation,
  } = data

  // boolean if component has an intro header
  const hasIntro = (title || image)

  return (
    <RowWrapper customMobilePaddingBottom="20px" {...data}>
      {hasIntro && (
        <Flex
          flexDirection={["column", null, null, "row"]}
          pt={[6, null, 4, "14vh"]}
          pb={[4, null, 6]}
        >
          <Box
            as="aside"
            width={[1, null, null, 1 / 2]}
            pl={[0, null, null, 4, 6]}
          >
            <Reveal delay={0.5} animation={revealAnimation} display="flex">
              <Flex justifyContent="center" alignItems="center">
                {title && <Text as={titleHeadingTag}>{title}</Text>}
                {image && (
                  <Image src={image.sourceUrl} width={[1, null, `60%`]} />
                )}
              </Flex>
            </Reveal>
          </Box>

          <Box as="aside" width={[1, null, null, 1 / 2]} pr={[0, null, 4]}>
            <Reveal delay={0.65} animation={revealAnimation} display="flex">
              <Box
                maxWidth="525px"
                mx={[null, null, null, `auto`]}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </Reveal>
          </Box>
        </Flex>
      )}

      {/* video */}
      {video && (
        <Box mx={["-20px", null, 0]}>
          <Reveal delay={0.9} animation={revealAnimation}>
            <VideoPlayer video={video} videoMobile={videoMobile} />
          </Reveal>
        </Box>
      )}
    </RowWrapper>
  )
}

export default RowIntroComponent
